import { callApi, handleResponse, handleError } from '@helpers/api';

const getPersonalNotesRequest = agent => () => agent.get('vFlow/note/?category=personal');
const putPersonalNotesRequest =
  agent =>
  ({ notesId, comment }) =>
    agent.put(`vFlow/note/${notesId}/`, { comment });
const postPersonalNotesRequest = agent => (comment, category) =>
  agent.post('vFlow/note/', { comment, category });
const getFilingNotesRequest = agent => payload =>
  agent.get(`${generateFilingNotesRequestUrl(payload)}`);
const putFilingNotesRequest = agent => payload =>
  agent.put(`vFlow/note/${payload.payload.notesId}/`, generateFilingNotePayload(payload.payload));
const postFilingNotesRequest = agent => payload =>
  agent.post('vFlow/note/', generateFilingNotePayload(payload.payload));

const generateFilingNotesRequestUrl = payload => {
  let url = 'vFlow/note/?category=all&note_type=filing';
  if (payload) {
    url = payload.navurl || 'vFlow/note/?category=all&note_type=filing';
    url = payload.savedfilingperiod
      ? `${url}&saved_filing_period=${payload.savedfilingperiod}`
      : url;
    url = payload.searchfor ? `${url}&search_for=${payload.searchfor}` : url;
    url = payload.incidents ? `${url}&incidents=${payload.incidents}` : url;
  }

  return url;
};

const generateFilingNotePayload = payload => {
  const allIncidents = [
    'issue_filed_late',
    'issue_paid_late',
    'issue_under_audit',
    'issue_tax_office_query',
    'issue_refund_outstanding',
    'issue_penalties_due',
    'issue_correction_to_be_filed',
  ];
  const output = {};
  allIncidents.forEach(incident => {
    output[incident] = !!payload.incidents.includes(incident);
  });
  output.category = 'saved_filing_period';
  output.comment = payload.comment;
  output.saved_filing_period = payload.saved_filing_period;
  return output;
};

export const putFilingNotes = async payload =>
  callApi(putFilingNotesRequest)(payload).then(handleResponse).catch(handleError);

export const postFilingNotes = async payload =>
  callApi(postFilingNotesRequest)(payload).then(handleResponse).catch(handleError);

export const getPersonalNotes = async () =>
  callApi(getPersonalNotesRequest)().then(handleResponse).catch(handleError);

export const putPersonalNotes = async (notesId, comment) =>
  callApi(putPersonalNotesRequest)({
    notesId,
    comment,
  })
    .then(handleResponse)
    .catch(handleError);

export const postPersonalNotes = async (comment, category) =>
  callApi(postPersonalNotesRequest)(comment, category).then(handleResponse).catch(handleError);

export const getFilingNotes = async payload =>
  callApi(getFilingNotesRequest)(payload).then(handleResponse).catch(handleError);
